// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"707edc53","746":"707edc53"}[chunkId] + ".chunk.css";
};